<section class="app-footer">
  <div class="container-fluid">
    <div>
      Copyright ©
      <a class="brand" target="_blank" [href]="AppConfig.productLink">{{ AppConfig.pageTitle }}</a>
      <a (click)="onUpdateRoutine()"> {{ AppConfig.version }}</a>
    </div>
    <div>Built with Love <i class="material-icons">favorite_border</i></div>
  </div>
</section>
